import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    OnInit,
    output,
    signal,
} from '@angular/core';

import {TranslatePipe} from '@brunata-angular/util';
import {
    NgbCollapse,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadComponent, TrueFalseComponent} from '@brunata-angular/ui';
import {ConsumptionAgentTranslated} from '../../consumption-agent.model';

@Component({
    selector: 'app-consumption-card',
    standalone: true,
    imports: [
        TranslatePipe,
        TrueFalseComponent,
        NgbDropdown,
        NgbDropdownItem,
        NgbDropdownMenu,
        NgbDropdownToggle,
        LoadComponent,
        NgbCollapse,
    ],
    templateUrl: './consumption-card.component.html',
    styleUrl: './consumption-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsumptionCardComponent implements OnInit {
    consumptionAgent = input.required<ConsumptionAgentTranslated>();
    buildingNo = input<string>();
    resultView = input<boolean>(false);

    deleteConsumptionAgent = output<{reportId: string; agentName: string}>();
    editConsumptionAgent = output<{reportId: string; agentName: string}>();
    duplicateConsumptionAgent = output<string>();

    private router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    protected isCollapsed = signal(false);

    readonly view = computed(() => ({
        buildingNo: this.buildingNo(),
        agent: this.consumptionAgent(),
        resultView: this.resultView(),
    }));

    ngOnInit(): void {
        this.isCollapsed.set(this.resultView());
    }

    toggleCollapse(isCollapsed: boolean): void {
        this.isCollapsed.set(isCollapsed);
    }

    editAgent(reportId: string, agentName: string): void {
        this.editConsumptionAgent.emit({reportId, agentName});
    }

    deleteAgent(reportId: string, agentName: string): void {
        this.deleteConsumptionAgent.emit({reportId, agentName});
    }

    duplicateAgent(reportId: string): void {
        this.duplicateConsumptionAgent.emit(reportId);
    }

    navigateToResults(consumptionAgent: ConsumptionAgentTranslated): void {
        void this.router.navigate(['./', consumptionAgent.reportId], {
            relativeTo: this.activatedRoute,
            queryParams: {
                reportId: consumptionAgent.reportId,
                consumptionToMonitor: consumptionAgent.consumptionToMonitor,
                agentType: consumptionAgent.agentType,
            },
        });
    }
}
